<template>
  <div class="hot-city-list">
    <div class="hotcity">
      <p>热门城市</p>
      <div
        v-for="(cityGroup, groupIndex) in cityGroups"
        :key="groupIndex"
        class="hotcity-box"
      >
        <button
          v-for="city in cityGroup"
          :key="city.id"
          class="hotcity-button"
          @click="changeCity(city)"
        >
          {{ city.name }}
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';

defineOptions({name: 'HotCityList'});

const props = defineProps({
  hotCities: {
    type: Array,
    default: () => []
  }
});

const emit = defineEmits(['changeCity']);

const cityGroups = computed(() => {
  const groups = [];
  for (let index = 0; index < props.hotCities.length; index += 3) {
    groups.push(props.hotCities.slice(index, index + 3));
  }
  return groups;
});

function changeCity (city) {
  if (city && city.name) {
    emit('changeCity', city);
  }
}
</script>

<style scoped>
.hot-city-list {
  background: var(--page-bg);
  padding-bottom: 10px;
}
.hot-city-list > .hotcity {
  height: 95px;
  padding: 0px 10px 0px 10px;
  box-sizing: border-box;
}
.hot-city-list > .hotcity > p {
  line-height: 30px;
  color: var(--text-muted);
}
.hot-city-list > .hotcity > .hotcity-box {
  height: 40px;
  box-sizing: border-box;
  padding-top: 0px;
}
.hot-city-list > .hotcity > .hotcity-box > .hotcity-button {
  box-sizing: border-box;
  border-radius: 4px;
  outline: none;
  height: 30px;
  margin: 0px;
  background: var(--surface-bg);
  color: var(--text-secondary);
  float: left;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 14px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  border: none;
  margin-right: 10px; /* 设置按钮之间的右侧间距 */
  width: 80px;
}
</style>
